import { Block } from '@ttab/elephant-api/newsdoc'

export const BYLINE_CREDIT_PATH = 'meta.core/byline-credit'

/** The one value the schema allows. See ttab/revisorschemas. */
const ORG = 'org'

/**
 * Whether the article is published under the organisation's name rather than
 * the authors'. The authors stay on the article either way.
 */
export function creditsOrganisation(credit: Array<{ value?: string }> | undefined): boolean {
  return credit?.some((block) => block.value === ORG) === true
}

/**
 * One block or none. Nothing to merge in a single value, so writing the whole
 * key is what it means: the last person to decide, decides.
 */
export function bylineCredit(org: boolean): Block[] {
  return org ? [Block.create({ type: 'core/byline-credit', value: ORG })] : []
}
